// ============================================================
// 3. src/plugins/logger.js (수정본)
// ============================================================

import { createConsola } from 'consola/browser';
import { setLogger } from '@/utils/logHelper';  // ✅ 추가

const MODE = process.env.NODE_ENV || 'development';
const IS_PROD = MODE === 'production';

const LEVEL_MAP = Object.freeze({
  off: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
  trace: 5
});

function resolveLevel(raw) {
  const key = String(raw || '').toLowerCase();
  const defaultLevel = IS_PROD ? 'warn' : 'debug';
  return LEVEL_MAP[key] ?? LEVEL_MAP[defaultLevel];
}

const ENV_LEVEL = process.env.VUE_APP_LOG_LEVEL;
const TAG = process.env.VUE_APP_NAME || 'MPNITE';

// 로거 인스턴스 생성
export const logger = createConsola({
  level: resolveLevel(ENV_LEVEL),
  formatOptions: {
    date: IS_PROD,
    colors: !IS_PROD,
    compact: IS_PROD
  }
}).withTag(TAG);

export default {
  install(app) {
    // ✅ logHelper에 로거 주입 (핵심 수정!)
    setLogger(logger);

    // 전역 주입
    app.config.globalProperties.$log = logger;
    app.provide('logger', logger);

    // 개발 환경에서만 warn 핸들러
    if (!IS_PROD) {
      app.config.warnHandler = (msg, instance, trace) => {
        const componentName = instance?.$options?.name
          || instance?.$?.type?.name
          || 'Anonymous';

        logger.warn('⚠️ Vue Warning', {
          component: componentName,
          message: msg,
          trace: trace?.slice(0, 3)
        });
      };
    }

    app.config.throwUnhandledErrorInProduction = true;
  }
};
